import { jsPDF } from "jspdf";
import "jspdf-autotable";
import ExportJsonExcel from "js-export-excel";

// (2026-10) Recibo de pago y estado de cuenta del módulo Pagos y Saldos (CxP)

const AZUL = [30, 58, 138];
const FONDO = [238, 244, 255];
const BORDE = [169, 180, 200];

export const moneda = (n) =>
  "$" +
  new Intl.NumberFormat("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(
    Number(n || 0)
  );
export const fechaCorta = (f) => {
  const [a, m, d] = String(f || "").slice(0, 10).split("-");
  return a && m && d ? `${d}/${m}/${a}` : String(f || "");
};
const empresa = () => String(process.env.REACT_APP_NOMBRE_INSTITUCION || "").toUpperCase();

const pie = (doc, texto) => {
  const pageW = doc.internal.pageSize.getWidth();
  const pageH = doc.internal.pageSize.getHeight();
  const n = doc.internal.getNumberOfPages();
  for (let i = 1; i <= n; i++) {
    doc.setPage(i);
    doc.setFont(undefined, "normal").setFontSize(8.5).setTextColor(60, 60, 60);
    doc.text(texto, 17, pageH - 12);
    doc.text(`Página ${i} de ${n}`, pageW - 17, pageH - 12, { align: "right" });
  }
};

const encabezado = (doc, titulo, folio) => {
  const pageW = doc.internal.pageSize.getWidth();
  doc.setFont(undefined, "bold").setFontSize(17).setTextColor(...AZUL);
  doc.text(empresa(), 17, 20);
  doc.setFontSize(11.5).setTextColor(37, 99, 235);
  doc.text(titulo, 17, 26.5);
  if (folio) {
    doc.setFontSize(10).setTextColor(...AZUL);
    doc.text(folio, pageW - 17, 22, { align: "right" });
  }
  doc.setTextColor(0).setFont(undefined, "normal");
};

const etiqueta = (content) => ({
  content,
  styles: { fillColor: FONDO, textColor: AZUL, fontStyle: "bold" },
});

// filas: [{ documento, detalle, importe }]
export function reciboPagoPDF({ proveedor, fecha, banco, observaciones, filas, tipo = "Pago" }) {
  const doc = new jsPDF();
  const pageW = doc.internal.pageSize.getWidth();
  const total = filas.reduce((t, f) => t + Number(f.importe || 0), 0);
  encabezado(doc, tipo === "Anticipo" ? "RECIBO DE ANTICIPO" : "RECIBO DE PAGO", `Fecha: ${fechaCorta(fecha)}`);
  doc.autoTable({
    startY: 30,
    margin: { left: 17, right: 17 },
    theme: "grid",
    styles: { fontSize: 9.5, cellPadding: 2, lineColor: BORDE, lineWidth: 0.25 },
    columnStyles: { 0: { cellWidth: 32 }, 2: { cellWidth: 26 }, 3: { cellWidth: 40 } },
    body: [
      [etiqueta(proveedor.tipo === "Maquilero" ? "Taller:" : "Proveedor:"), proveedor.nombre, etiqueta("Banco:"), banco || ""],
      [etiqueta("Observaciones:"), { content: observaciones && observaciones !== "NA" ? observaciones : "", colSpan: 3 }],
    ],
  });
  doc.autoTable({
    startY: doc.autoTable.previous.finalY + 6,
    margin: { left: 17, right: 17 },
    theme: "grid",
    head: [["DOCUMENTO", "DETALLE", "IMPORTE"]],
    body: filas.map((f) => [f.documento, f.detalle || "", moneda(f.importe)]),
    foot: [["", "TOTAL", moneda(total)]],
    styles: { fontSize: 10, cellPadding: 2.3, lineColor: BORDE, lineWidth: 0.25 },
    headStyles: { fillColor: AZUL, textColor: 255, halign: "center" },
    footStyles: { fillColor: FONDO, textColor: AZUL, fontStyle: "bold", halign: "right" },
    columnStyles: { 0: { cellWidth: 40 }, 2: { cellWidth: 40, halign: "right" } },
  });
  const y = doc.autoTable.previous.finalY + 34;
  doc.setDrawColor(...AZUL).setLineWidth(0.35);
  doc.line(25, y, 93, y);
  doc.line(pageW - 93, y, pageW - 25, y);
  doc.setFont(undefined, "bold").setFontSize(10).setTextColor(...AZUL);
  doc.text("Entregó", 59, y + 5.5, { align: "center" });
  doc.text(proveedor.tipo === "Maquilero" ? "Recibió (Taller)" : "Recibió", pageW - 59, y + 5.5, { align: "center" });
  pie(doc, `${empresa()} - ${tipo === "Anticipo" ? "Recibo de anticipo" : "Recibo de pago"} · ${proveedor.nombre}`);
  doc.save(`${tipo === "Anticipo" ? "Anticipo" : "Pago"} ${proveedor.nombre} ${fecha}.pdf`);
}

const columnasEdo = ["Fecha", "Movimiento", "Concepto", "Cargo", "Abono", "Saldo"];

export function estadoCuentaPDF(ec) {
  const doc = new jsPDF();
  const rango =
    ec.inicio || ec.fin
      ? `Del ${ec.inicio ? fechaCorta(ec.inicio) : "inicio"} al ${ec.fin ? fechaCorta(ec.fin) : "día de hoy"}`
      : "Todos los movimientos";
  encabezado(doc, "ESTADO DE CUENTA", rango);
  doc.autoTable({
    startY: 30,
    margin: { left: 17, right: 17 },
    theme: "grid",
    styles: { fontSize: 9.5, cellPadding: 2, lineColor: BORDE, lineWidth: 0.25 },
    body: [
      [
        etiqueta(ec.proveedor.tipo === "Maquilero" ? "Taller:" : "Proveedor:"),
        ec.proveedor.nombre,
        etiqueta("Saldo inicial:"),
        { content: moneda(ec.saldoInicial), styles: { halign: "right" } },
      ],
      [
        etiqueta("Cargos:"),
        { content: moneda(ec.cargos), styles: { halign: "right" } },
        etiqueta("Abonos:"),
        { content: moneda(ec.abonos), styles: { halign: "right" } },
      ],
      [
        etiqueta("Saldo final:"),
        { content: moneda(ec.saldoFinal), colSpan: 3, styles: { fontStyle: "bold", textColor: AZUL } },
      ],
    ],
  });
  doc.autoTable({
    startY: doc.autoTable.previous.finalY + 6,
    margin: { left: 17, right: 17, bottom: 18 },
    theme: "grid",
    head: [columnasEdo.map((c) => c.toUpperCase())],
    body: ec.movimientos.map((m) => [
      fechaCorta(m.fecha),
      m.tipo,
      m.concepto,
      m.cargo ? moneda(m.cargo) : "",
      m.abono ? moneda(m.abono) : "",
      moneda(m.saldo),
    ]),
    styles: { fontSize: 8.5, cellPadding: 1.8, lineColor: BORDE, lineWidth: 0.25 },
    headStyles: { fillColor: AZUL, textColor: 255, halign: "center" },
    columnStyles: {
      0: { cellWidth: 20 },
      1: { cellWidth: 25 },
      3: { cellWidth: 24, halign: "right" },
      4: { cellWidth: 24, halign: "right" },
      5: { cellWidth: 26, halign: "right" },
    },
    rowPageBreak: "avoid",
  });
  pie(doc, `${empresa()} - Estado de cuenta · ${ec.proveedor.nombre}`);
  doc.save(`Estado de cuenta ${ec.proveedor.nombre}.pdf`);
}

// ---- (2026-10) Futuras entregas: agrupadas por semana de su fecha compromiso
// (las atrasadas primero), para preparar lo que se va a pagar
const isoDia = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
export function grupoEntrega(f) {
  if (f.atrasada) return { clave: "0", etiqueta: "Atrasadas (ya pasó su fecha compromiso)" };
  const d = new Date(`${String(f.fechaCompromiso || "").slice(0, 10)}T12:00:00`);
  if (isNaN(d)) return { clave: "9", etiqueta: "Sin fecha compromiso" };
  const lunes = new Date(d);
  lunes.setDate(d.getDate() - ((d.getDay() + 6) % 7));
  const domingo = new Date(lunes);
  domingo.setDate(lunes.getDate() + 6);
  return {
    clave: `1-${isoDia(lunes)}`,
    etiqueta: `Semana del ${fechaCorta(isoDia(lunes))} al ${fechaCorta(isoDia(domingo))}`,
  };
}
export function agrupaFuturas(filas) {
  const grupos = {};
  filas.forEach((f) => {
    const g = grupoEntrega(f);
    if (!grupos[g.clave]) grupos[g.clave] = { ...g, filas: [], pendientes: 0, importe: 0, aPagar: 0 };
    const x = grupos[g.clave];
    x.filas.push(f);
    x.pendientes += Number(f.pendientes || 0);
    x.importe += Number(f.importe || 0);
    x.aPagar += Number(f.aPagar || 0);
  });
  return Object.values(grupos).sort((a, b) => a.clave.localeCompare(b.clave));
}

const columnasFuturas = ["CONTRATO", "TALLER", "ARTÍCULO", "COMPROMISO", "POR ENTREGAR", "PRECIO", "IMPORTE", "ANTICIPO", "A PAGAR"];

export function futurasEntregasPDF(filas, titulo = "FUTURAS ENTREGAS") {
  const doc = new jsPDF("landscape");
  const grupos = agrupaFuturas(filas);
  const total = filas.reduce((t, f) => t + Number(f.aPagar || 0), 0);
  encabezado(doc, titulo, `Por pagar al entregar: ${moneda(total)}`);
  const body = [];
  grupos.forEach((g) => {
    body.push([
      {
        content: `${g.etiqueta}  ·  ${g.filas.length} contrato(s)  ·  ${new Intl.NumberFormat("en-US").format(g.pendientes)} pzs  ·  ${moneda(g.aPagar)}`,
        colSpan: columnasFuturas.length,
        styles: { fillColor: g.clave === "0" ? [254, 226, 226] : FONDO, textColor: g.clave === "0" ? [185, 28, 28] : AZUL, fontStyle: "bold" },
      },
    ]);
    g.filas.forEach((f) =>
      body.push([
        `${f.folio}${f.corte ? ` · C${f.corte}` : ""}`,
        f.proveedor?.nombre || "",
        `${f.articulo}${f.proceso ? ` (${f.proceso})` : ""}`,
        fechaCorta(f.fechaCompromiso),
        `${f.pendientes} de ${f.piezas}`,
        moneda(f.precio),
        moneda(f.importe),
        f.anticipoDisponible ? moneda(f.anticipoDisponible) : "",
        moneda(f.aPagar),
      ])
    );
  });
  doc.autoTable({
    startY: 32,
    margin: { left: 12, right: 12, bottom: 18 },
    theme: "grid",
    head: [columnasFuturas],
    body,
    foot: [[{ content: "TOTAL", colSpan: 6, styles: { halign: "right" } }, moneda(filas.reduce((t, f) => t + Number(f.importe || 0), 0)), "", moneda(total)]],
    showFoot: "lastPage",
    styles: { fontSize: 8.5, cellPadding: 1.6, lineColor: BORDE, lineWidth: 0.25 },
    headStyles: { fillColor: AZUL, textColor: 255, halign: "center" },
    footStyles: { fillColor: FONDO, textColor: AZUL, fontStyle: "bold", halign: "right" },
    columnStyles: {
      0: { cellWidth: 24 },
      3: { cellWidth: 24, halign: "center" },
      4: { cellWidth: 26, halign: "center" },
      5: { cellWidth: 22, halign: "right" },
      6: { cellWidth: 28, halign: "right" },
      7: { cellWidth: 24, halign: "right" },
      8: { cellWidth: 28, halign: "right", fontStyle: "bold" },
    },
    rowPageBreak: "avoid",
  });
  pie(doc, `${empresa()} - Futuras entregas`);
  doc.save(`Futuras entregas ${new Date().toISOString().slice(0, 10)}.pdf`);
}

export function futurasEntregasExcel(filas) {
  const claves = ["semana", "contrato", "corte", "taller", "proceso", "articulo", "compromiso", "piezas", "recibidas", "pendientes", "precio", "importe", "anticipo", "aPagar"];
  new ExportJsonExcel({
    fileName: "Futuras entregas",
    datas: [
      {
        sheetName: "Futuras entregas",
        sheetFilter: claves,
        sheetHeader: ["Semana", "Contrato", "Corte", "Taller", "Proceso", "Artículo", "Compromiso", "Piezas", "Recibidas", "Por entregar", "Precio", "Importe", "Anticipo disponible", "A pagar"],
        sheetData: agrupaFuturas(filas).flatMap((g) =>
          g.filas.map((f) => ({
            semana: g.etiqueta,
            contrato: f.folio,
            corte: f.corte,
            taller: f.proveedor?.nombre || "",
            proceso: f.proceso,
            articulo: f.articulo,
            compromiso: f.fechaCompromiso,
            piezas: f.piezas,
            recibidas: f.recibidas,
            pendientes: f.pendientes,
            precio: f.precio,
            importe: f.importe,
            anticipo: f.anticipoDisponible,
            aPagar: f.aPagar,
          }))
        ),
      },
    ],
  }).saveExcel();
}

export function estadoCuentaExcel(ec) {
  const claves = ["fecha", "tipo", "concepto", "cargo", "abono", "saldo"];
  new ExportJsonExcel({
    fileName: `Estado de cuenta ${ec.proveedor.nombre}`,
    datas: [
      {
        sheetName: "Estado de cuenta",
        sheetFilter: claves,
        sheetHeader: columnasEdo,
        sheetData: [
          { fecha: "", tipo: "", concepto: "Saldo inicial", cargo: "", abono: "", saldo: ec.saldoInicial },
          ...ec.movimientos.map((m) => ({
            fecha: m.fecha,
            tipo: m.tipo,
            concepto: m.concepto,
            cargo: m.cargo || "",
            abono: m.abono || "",
            saldo: m.saldo,
          })),
          { fecha: "", tipo: "", concepto: "Saldo final", cargo: ec.cargos, abono: ec.abonos, saldo: ec.saldoFinal },
        ],
      },
    ],
  }).saveExcel();
}
